/* ============================================================
   KAFFEESACK — 1KG ALS STANDARD-VARIANTE v4
   Datei: assets/kaffeesack-1kg-default.js

   Wählt auf Produktseiten automatisch die größte Variante
   (1000 Gramm / 1 Kg) aus, sofern vorhanden.
   ============================================================ */

(function() {
  'use strict';

  var MAX_ATTEMPTS = 10;
  var DELAY = 250;
  var attempts = 0;

  /* Prüft ob ein Wert die 1kg/1000g-Option ist */
  function isLargeSize(raw) {
    var v = (raw || '').toLowerCase().replace(/\s+/g, '').replace(/\u00a0/g, '');
    return v === '1kg' ||
           v === '1000g' ||
           v === '1000gramm' ||
           v.indexOf('1kg') === 0 ||
           v.indexOf('1000g') === 0 ||
           v.indexOf('1000gramm') === 0;
  }

  function select1kg() {
    attempts++;

    var form = document.querySelector('[data-product-form]');
    if (!form) {
      if (attempts < MAX_ATTEMPTS) setTimeout(select1kg, DELAY);
      return;
    }

    var found = false;

    /* 1: Radio-Buttons prüfen */
    var radios = form.querySelectorAll('input[type="radio"][data-single-option-selector]');
    var targetRadio = null;
    radios.forEach(function(radio) {
      if (isLargeSize(radio.value)) {
        if (radio.checked) {
          found = true;
          console.log('[KS-1kg] Bereits ausgewählt (Radio): "' + radio.value + '"');
        } else {
          targetRadio = radio;
        }
      }
    });

    if (found) return;

    if (targetRadio) {
      console.log('[KS-1kg] Setze Radio auf: "' + targetRadio.value + '"');
      targetRadio.checked = true;
      targetRadio.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    /* 2: Select-Dropdowns prüfen */
    var selects = form.querySelectorAll('select[data-single-option-selector]');
    selects.forEach(function(sel) {
      if (found) return;
      var options = sel.querySelectorAll('option');
      options.forEach(function(opt) {
        if (found) return;
        if (isLargeSize(opt.value) || isLargeSize(opt.textContent)) {
          if (sel.value === opt.value) {
            console.log('[KS-1kg] Bereits ausgewählt (Select): "' + opt.value + '"');
            found = true;
          } else {
            console.log('[KS-1kg] Setze Select auf: "' + opt.value + '"');
            sel.value = opt.value;
            sel.dispatchEvent(new Event('change', { bubbles: true }));
            found = true;
          }
        }
      });
    });

    if (found) return;

    /* 3: Fallback — versteckten Variant-Select durchsuchen */
    var variantSelect = form.querySelector('[data-product-select]');
    if (variantSelect) {
      var variantOpts = variantSelect.querySelectorAll('option');
      variantOpts.forEach(function(opt) {
        if (found) return;
        var text = (opt.textContent || '').toLowerCase().replace(/\s+/g, '');
        if ((text.indexOf('1000gramm') !== -1 || text.indexOf('1kg') !== -1) && !opt.disabled) {
          console.log('[KS-1kg] Fallback Variant-Select: id=' + opt.value + ', text="' + opt.textContent.trim() + '"');
          variantSelect.value = opt.value;
          variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
          found = true;
        }
      });
    }

    if (!found && attempts < MAX_ATTEMPTS) {
      setTimeout(select1kg, DELAY);
    } else if (!found) {
      console.log('[KS-1kg] Keine 1kg-Option bei diesem Produkt');
    }
  }

  /* Warte bis Theme-JS initialisiert hat */
  function init() {
    var el = document.querySelector('[data-product-template], [data-section-type="product"]');
    if (!el) return;
    console.log('[KS-1kg] Produktseite erkannt, starte...');
    setTimeout(select1kg, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
